export default {
  resetProjectsState: (state) => {
    state.projects = [];
  },
  setSelectedProjectId: (state, project_id) => {
    state.selectedProjectId = project_id;
  },
  deleteProject: (state, project_id) => {
    const index = state.projects.findIndex(
      (project) => project.project_id === project_id
    );
    state.projects.splice(index, 1);
  },
  setAllProjects: (state, projects) => {
    const copy = projects.slice();
    copy.reverse();
    state.projects = copy;
  },
  setSelectedProjectEmails: (state, emails) => {
    state.selectedProjectEmails = emails;
  },
  setProjectUsers: (state, { project_id, shareAccess: users }) => {
    state.projects.find((project) => project.project_id === project_id).users =
      users;
  },
  removeProjectUser: (state, { project_id, revokedEmail }) => {
    state.projects.find((project) => project.project_id === project_id).users =
      state.projects
        .find((project) => project.project_id === project_id)
        .users.filter((user) => user.email != revokedEmail);
  },
};
